// src/locales/vant-my-MM.ts
const myMM = {
    name: 'အမည်',
    tel: 'ဖုန်းနံပါတ်',
    save: 'သိမ်းဆည်းမည်',
    clear: 'ရှင်းလင်းမည်',
    cancel: 'ပယ်ဖျက်မည်',
    confirm: 'အတည်ပြုမည်',
    delete: 'ဖျက်မည်',
    loading: 'တင်နေသည်...',
    noCoupon: 'ကူပွန်မရှိပါ',
    nameEmpty: 'ကျေးဇူးပြု၍ အမည်ထည့်ပါ',
    addContact: 'ဆက်သွယ်ရန်ထည့်ပါ',
    telInvalid: 'ဖုန်းနံပါတ် မှားယွင်းနေသည်',

    vanCalendar: {
        end: 'ပြီး',
        start: 'စ',
        title: 'ပြက္ခဒိန်',
        weekdays: [
            'တနင်္ဂနွေ',
            'တနင်္လာ',
            'အင်္ဂါ',
            'ဗုဒ္ဓဟူး',
            'ကြာသပတေး',
            'သောကြာ',
            'စနေ'
        ],
        monthTitle: (year: number, month: number) => `${year}နှစ် ${month}လ`,
        rangePrompt: (maxRange: number) => `${maxRange} ရက်ထက် မပိုပါနှင့်`
    },

    vanCascader: {
        select: 'ရွေးချယ်ပါ'
    },

    vanPagination: {
        prev: 'ရှေ့',
        next: 'နောက်'
    },

    vanPullRefresh: {
        pulling: 'ဆွဲချပြီး ပြန်လည်စတင်ရန်...',
        loosing: 'ပြန်လည်စတင်ရန် လွှတ်လိုက်ပါ...'
    },

    vanSubmitBar: {
        label: 'စုစုပေါင်း:'
    },

    vanCoupon: {
        unlimited: 'အကန့်အသတ်မရှိ',
        discount: (discount: number) => `${discount * 10}% လျှော့စျေး`,
        condition: (condition: number) => `အနည်းဆုံး ${condition}`
    },

    vanCouponCell: {
        title: 'ကူပွန်',
        count: (count: number) => `သင့်မှာ ကူပွန် ${count} ခု ရှိသည်`
    },

    vanCouponList: {
        exchange: 'လဲလှယ်မည်',
        close: 'ပိတ်မည်',
        enable: 'အသုံးပြုနိုင်သည်',
        disabled: 'အသုံးမပြုနိုင်ပါ',
        placeholder: 'ကူပွန်ကုဒ်'
    },

    vanAddressEdit: {
        area: 'နယ်မြေ',
        areaEmpty: 'ကျေးဇူးပြု၍ လက်ခံမည့်နယ်မြေရွေးပါ',
        addressEmpty: 'လိပ်စာ ဗလာမဖြစ်ရပါ',
        addressDetail: 'လိပ်စာ',
        defaultAddress: 'ပုံမှန်လိပ်စာအဖြစ် သတ်မှတ်မည်'
    },

    vanAddressList: {
        add: 'လိပ်စာအသစ်ထည့်မည်'
    }
};

export default myMM;